<template>
  <router-view></router-view>
</template>

<script>
  import store from "./store";
  export default {
    mounted() {
      // this.$notify(
      //   {
      //     component: NotificationSample,
      //     icon: 'nc-icon nc-app'
      //   })
    },
  };
</script>

<style lang="css">
  :root {
    --font-primary: 13px;
    --font-medium: 13px;
    --font-large: 14px;
    --color-primary: #343232;
  }

  .font-primary {
    font-size: var(--font-primary);
  }

  .font-medium {
    font-size: var(--font-medium);
  }

  .font-large {
    font-size: var(--font-large);
  }

  .el-input__inner {
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: var(--color-primary);
    height: 40px;
    line-height: 40px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
    width: 100%;
  }

  .el-select:hover ::v-deep .el-input,
  .el-select:hover ::v-deep .el-input__clear,
  .el-select:hover ::v-deep .el-select__caret,
  .el-select:hover ::v-deep .el-input__inner {
    display: inline-flex !important;
    opacity: 1 !important;
    visibility: visible !important;
  }

  .el-select .el-input:hover input {
    color: black;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #F5F7FA;
    border-color: #8e8e8e;
  }

  .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
    border-color: #000000;
  }

  .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #F5F7FA;
    border-color: #8e8e8e;
    cursor: not-allowed;
  }

  .el-input.is-disabled .el-input__inner {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #707887;
    cursor: not-allowed;
  }

  .el-button[disabled],
  .el-button:disabled {
    opacity: 0.6 !important;
  }


  .el-radio__input.is-disabled+span.el-radio__label {
    color: #707887;
    cursor: not-allowed;
  }

  .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
    background-color: #707887;
  }

  .el-radio__input.is-disabled .el-radio__inner,
  .el-radio__input.is-disabled.is-checked .el-radio__inner {
    background-color: #F5F7FA;
    border-color: #707887;
  }

  .el-textarea.is-disabled .el-textarea__inner {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #707887;
    cursor: not-allowed;
  }

  .vs--disabled .vs__clear,
  .vs--disabled .vs__dropdown-toggle,
  .vs--disabled .vs__open-indicator,
  .vs--disabled .vs__search,
  .vs--disabled .vs__selected {
    background-color: #F5F7FA !important;
    cursor: var(--vs-disabled-cursor);
    border-color: #E4E7ED;
  }

  /* .vs--disabled .vs__search,
.vs--disabled .vs__search:focus {
  display: none !important;
} */

  .vs__search,
  .vs__search:focus {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: none;
    border: 1px solid transparent;
    border-left: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #565f74 !important;
    -webkit-box-flex: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    font-size: 0.8rem !important;
    line-height: var(--vs-line-height);
    margin: 4px 0 0;
    max-width: 100%;
    outline: none;
    padding: 0 7px;
    width: 0;
    z-index: 1;
    margin-left: 5px !important;
  }


  .vs__selected {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: var(--vs-selected-bg);
    border: var(--vs-selected-border-width) var(--vs-selected-border-style) rgb(204 124 124 / 26%);
    border-radius: var(--vs-border-radius);
    color: var(--font-primary) !important;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: var(--vs-line-height);
    margin: 4px 2px 0;
    padding: 0 .25em;
    z-index: 0;
    margin-left: 10px !important;
  }

  #my-select .vue-select .vs__dropdown-toggle,
  .vue-select .vs__dropdown-menu .vs__option {
    font-size: var(--font-primary) !important;
  }

  .vs__clear {
    display: none;
  }

  body .el-message-box__wrapper .el-message-box__btns {
    display: flex !important;
    flex-direction: row-reverse !important;
  }

  body .el-message-box__wrapper .el-message-box__btns .el-button:first-child {
    margin-left: 10px !important;
  }

  input[type="checkbox"] {
    pointer-events: none;
  }


  label {
    font-size: var(--font-primary);
    font-weight: bold;
    color: #3A3A3A !important;
  }

  .el-checkbox__label {
    font-size: var(--font-primary);
  }

  .card {
    margin-bottom: 10px;
  }

  .clickable-card {
    cursor: pointer;
    transition: all 0.2s ease;
    height: 100%;
  }

  .clickable-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }


  .accident-card-clickable {
    cursor: pointer;
    transition: all 0.2s ease;
    height: 100%;
  }

  .accident-card-clickable:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .el-radio__label {
    font-size: var(--font-primary);
    padding-left: 10px;
  }

  .el-table thead {
    color: var(--color-primary) !important;
  }

  .el-button--mini,
  .el-button--small {
    font-size: var(--font-primary);
    border-radius: 3px;
  }

  .navbar .navbar-brand {
    color: var(--color-primary) !important;
  }

  .el-table .el-table__row td {
    padding: 2px 0 !important;
    font-size: var(--font-primary) !important;
    color: var(--color-primary) !important;
  }

  .el-table .el-table__header th {
    padding: 4px 0 !important;
    font-size: var(--font-medium) !important;
  }

  .el-table__body tr:nth-child(odd) {
    background-color: #ffffff;
  }

  .el-table__body tr:nth-child(even):not(.table-info tr) {
    background-color: #f9f9f9;
  }

  .el-table .cell {
    padding: 0px 8px !important;
  }

  .el-table .el-table__cell {
    padding: 4px 0 !important;
  }

  .el-table .el-table__expanded-cell:hover {
    background-color: white !important;
  }

  .el-table .el-table__cell .center {
    text-align: center;
  }

  /* .el-table thead th {
  background-color: #F5F5F5 !important;
} */
</style>